<template>
  <div>
    <label>{{ $t("brand.label") }}</label>
    <p class="help-block">{{ $t("brand.help") }}</p>
    <div v-if="brands.length" class="brand-selector">
      <div @click.stop="showDropdown = true" class="btn btn-default">
        <img :src="selectedBrand.logo" :alt="`${selectedBrand.name} logo`">
        <span>{{ selectedBrand.name }}</span>
        <span class="glyphicon glyphicon-menu-down" aria-hidden="true"></span>
      </div>
      <div class="dropdown-menu-container">
        <ul class="dropdown-menu" :class="{'show': showDropdown}">
          <li v-for="brand in brands" @click.stop="selectBrand(brand)">
            <img :src="brand.logo" :alt="`${brand.name} logo`">
            <span class="brand-name">{{ brand.name }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
// Brand selector component
// Allows the user to pick a brand from a dropdown list

export default {
  data () {
    return {
      'showDropdown': false
    }
  },
  props: ['brands', 'value'],
  computed: {
    selectedBrand () {
      // find the corresponding brand object based on
      // the id passed in the 'value' prop
      let result = this.brands.find((brand) => {
        return brand.id === this.value
      })
      if (typeof result === 'undefined' && this.brands.length) {
        // fallack to showing the first brand
        return this.brands[0]
      } else {
        return result
      }
    }
  },
  mounted () {
    // detect clicks outside of the dropdown menu
    document.body.addEventListener('click', this.hideDropdown)
  },
  beforeDestroy () {
    // clean up event listeners
    document.body.removeEventListener('click', this.hideDropdown)
  },
  methods: {
    selectBrand (brand) {
      this.showDropdown = false
      this.$emit('input', brand.id)
    },
    hideDropdown () {
      event.stopPropagation()
      this.showDropdown = false
    }
  }
}
</script>

<style scoped>
.brand-selector {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// SelectBrand.vue?029017bf